export const INCOME_CORRECTIONS = [
  {
    value: "alimony_for_children_dependents"
  },
  {
    value: "deposit_interest_individuals"
  },
  {
    value: "interest_debt_securities"
  },
  {
    value: "interest_government_securities"
  },
  {
    value: "capital_gains_government_securities"
  },
  {
    value: "capital_gains_agent_bonds"
  },
  {
    value: "dividends_official_stock_exchange"
  },
  {
    value: "dividends_conditions_3_years"
  },
  {
    value: "income_other_services"
  },
  {
    value: "income_service_officers"
  },
  {
    value: "lottery_winning"
  },
  {
    value: "public_works_training"
  },
  {
    value: "income_personal_farming"
  },
  {
    value: "capital_gains_kazakhstan_residents"
  },
  {
    value: "capital_gains_stock_exchange"
  },
  {
    value: "government_benefits_budget_funds"
  },
  {
    value: "tax_free_payments_limits"
  },
  {
    value: "official_income_diplomatic_staff"
  },
  {
    value: "official_income_foreign_civil_servants"
  },
  {
    value: "official_income_kz_diplomats_abroad"
  },
  {
    value: "age_pension_payments"
  },
  {
    value: "housing_deposit_bonus"
  },
  {
    value: "education_deposit_bonus"
  },
  {
    value: "education_expenses"
  },
  {
    value: "social_payments"
  },
  {
    value: "employer_maternity_leave_payment"
  },
  {
    value: "scholarships_paid_by_organizations"
  },
  {
    value: "presidential_scholarships"
  },
  {
    value: "government_named_scholarships"
  },
  {
    value: "bolashak_scholarship_expenses"
  },
  {
    value: "travel_compensation_for_students"
  },
  {
    value: "property_received_as_gift"
  },
  {
    value: "charitable_assistance_value"
  },
  {
    value: "children_camp_vouchers"
  },
  {
    value: "insurance_claims_due_to_accidents"
  },
  {
    value: "insurance_claims_from_personal_policies"
  },
  {
    value: "redeemed_sums_life_insurance"
  },
  {
    value: "trust_management_income"
  },
  {
    value: "dividends_from_foreign_company"
  },
  {
    value: "investment_deposit_income"
  },
  {
    value: "state_social_assistance"
  },
  {
    value: "compensation_for_harm_to_health"
  },
  {
    value: "accident_insurance_payments"
  },
  {
    value: "court_awarded_compensation"
  },
  {
    value: "humanitarian_aid_value"
  },
  {
    value: "mandatory_employer_insurance_premiums"
  },
  {
    value: "grant_payments"
  },
  {
    value: "metal_scrap_income"
  },
  {
    value: "excluded_law_2020"
  },
  {
    value: "taxable_employee_income"
  },
  {
    value: "special_citizen_income_tax"
  },
  {
    value: "employee_income_from_media"
  },
  {
    value: "travel_accommodation_food_expenses"
  },
  {
    value: "voluntary_insurance_premiums"
  },
  {
    value: "unused_guarantee_compensation"
  },
  {
    value: "interest_investment_deposit"
  },
  {
    value: "export_income_of_individuals"
  }
];

export const STANDARD_TAXES = [
  {
    disabled: false,
    value: "ipn_calc_2018_2022"
  },
  {
    disabled: false,
    value: "ipn_calc_2022"
  },
  {
    disabled: false,
    value: "mci_882_wwii_participant"
  },
  {
    disabled: false,
    value: "mci_882_child_disability"
  },
];

export const OTHER_TAXES = [
  {
    value: "tax_deduction_voluntary_pension"
  },
  {
    value: "tax_deduction_medical"
  },
  {
    value: "tax_deduction_rewards"
  },
];
